import React, { useState } from 'react';

const CORRECT_PASSWORD = 'FERRYS';

export default function PasswordGate({ onAuth }) {
  const [value, setValue] = useState('');
  const [error, setError] = useState(false);
  const [shake, setShake] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const success = onAuth(value);
    if (!success) {
      setError(true);
      setShake(true);
      setTimeout(() => setShake(false), 500);
      setTimeout(() => setError(false), 3000);
      setValue('');
    }
  };

  return (
    <div className="password-gate">
      <video
        className="hero-video-layer"
        src="/Backgroundwaves.mp4"
        autoPlay
        loop
        muted
        playsInline
      />
      <div className="password-gate-inner">
        <div className="pg-script">See You in Naples!</div>

        <div className="pg-subtitle">Love, The Future Ferrys</div>

        <div className="pg-divider">
          <span />
          <i>✦</i>
          <span />
        </div>

        <form className="pg-form" onSubmit={handleSubmit}>
          <div className="pg-hint">Enter password to view wedding details</div>
          <div className={`pg-input-row${shake ? ' error' : ''}`}>
            <input
              className="pg-input"
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={value}
              onChange={(e) => setValue(e.target.value.toUpperCase())}
              autoComplete="off"
            />
            <button
              type="button"
              className="pg-toggle-vis"
              onClick={() => setShowPassword(!showPassword)}
              aria-label={showPassword ? "Hide password" : "Show password"}
            >
              {showPassword ? (
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                  <circle cx="12" cy="12" r="3"/>
                  <line x1="4" y1="4" x2="20" y2="20"/>
                </svg>
              ) : (
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                  <circle cx="12" cy="12" r="3"/>
                </svg>
              )}
            </button>
            <button type="submit" className="pg-submit" aria-label="Submit">
              →
            </button>
          </div>

          {error && (
            <div className="pg-error">Incorrect password — try again</div>
          )}
        </form>

        <div className="pg-date">10 · 30 · 2026 · Naples, FL</div>
      </div>
    </div>
  );
}
